// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ITriggerConfigRenewalDto } from './ITriggerConfigRenewalDto';
import {
    ITriggerConfigRenewalDtoFromJSON,
    ITriggerConfigRenewalDtoFromJSONTyped,
    ITriggerConfigRenewalDtoToJSON,
    ITriggerConfigRenewalDtoToJSONTyped,
} from './ITriggerConfigRenewalDto';
import type { ICategorySpendLimitRenewalDto } from './ICategorySpendLimitRenewalDto';
import {
    ICategorySpendLimitRenewalDtoFromJSON,
    ICategorySpendLimitRenewalDtoFromJSONTyped,
    ICategorySpendLimitRenewalDtoToJSON,
    ICategorySpendLimitRenewalDtoToJSONTyped,
} from './ICategorySpendLimitRenewalDto';
import type { IAutoFundingConfigRenewalDto } from './IAutoFundingConfigRenewalDto';
import {
    IAutoFundingConfigRenewalDtoFromJSON,
    IAutoFundingConfigRenewalDtoFromJSONTyped,
    IAutoFundingConfigRenewalDtoToJSON,
    IAutoFundingConfigRenewalDtoToJSONTyped,
} from './IAutoFundingConfigRenewalDto';

/**
 * 
 * @export
 * @interface IDeductibleConfigRenewalDto
 */
export interface IDeductibleConfigRenewalDto {
    /**
     * 
     * @type {number}
     * @memberof IDeductibleConfigRenewalDto
     */
    parent_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IDeductibleConfigRenewalDto
     */
    coverage_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IDeductibleConfigRenewalDto
     */
    coverage_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IDeductibleConfigRenewalDto
     */
    coverage_code?: string;
    /**
     * 
     * @type {Array<ITriggerConfigRenewalDto>}
     * @memberof IDeductibleConfigRenewalDto
     */
    trigger_configs?: Array<ITriggerConfigRenewalDto>;
    /**
     * 
     * @type {Array<IAutoFundingConfigRenewalDto>}
     * @memberof IDeductibleConfigRenewalDto
     */
    auto_funding_configs?: Array<IAutoFundingConfigRenewalDto>;
    /**
     * 
     * @type {Array<ICategorySpendLimitRenewalDto>}
     * @memberof IDeductibleConfigRenewalDto
     */
    category_spend_limits?: Array<ICategorySpendLimitRenewalDto>;
}

/**
 * Check if a given object implements the IDeductibleConfigRenewalDto interface.
 */
export function instanceOfIDeductibleConfigRenewalDto(value: object): value is IDeductibleConfigRenewalDto {
    return true;
}

export function IDeductibleConfigRenewalDtoFromJSON(json: any): IDeductibleConfigRenewalDto {
    return IDeductibleConfigRenewalDtoFromJSONTyped(json, false);
}

export function IDeductibleConfigRenewalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDeductibleConfigRenewalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'coverage_id': json['coverage_id'] == null ? undefined : json['coverage_id'],
        'coverage_name': json['coverage_name'] == null ? undefined : json['coverage_name'],
        'coverage_code': json['coverage_code'] == null ? undefined : json['coverage_code'],
        'trigger_configs': json['trigger_configs'] == null ? undefined : ((json['trigger_configs'] as Array<any>).map(ITriggerConfigRenewalDtoFromJSON)),
        'auto_funding_configs': json['auto_funding_configs'] == null ? undefined : ((json['auto_funding_configs'] as Array<any>).map(IAutoFundingConfigRenewalDtoFromJSON)),
        'category_spend_limits': json['category_spend_limits'] == null ? undefined : ((json['category_spend_limits'] as Array<any>).map(ICategorySpendLimitRenewalDtoFromJSON)),
    };
}

export function IDeductibleConfigRenewalDtoToJSON(json: any): IDeductibleConfigRenewalDto {
    return IDeductibleConfigRenewalDtoToJSONTyped(json, false);
}

export function IDeductibleConfigRenewalDtoToJSONTyped(value?: IDeductibleConfigRenewalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parent_id': value['parent_id'],
        'coverage_id': value['coverage_id'],
        'coverage_name': value['coverage_name'],
        'coverage_code': value['coverage_code'],
        'trigger_configs': value['trigger_configs'] == null ? undefined : ((value['trigger_configs'] as Array<any>).map(ITriggerConfigRenewalDtoToJSON)),
        'auto_funding_configs': value['auto_funding_configs'] == null ? undefined : ((value['auto_funding_configs'] as Array<any>).map(IAutoFundingConfigRenewalDtoToJSON)),
        'category_spend_limits': value['category_spend_limits'] == null ? undefined : ((value['category_spend_limits'] as Array<any>).map(ICategorySpendLimitRenewalDtoToJSON)),
    };
}

